import React from 'react';
import { Modal, Button, Result } from 'antd';
import { Trans } from "@lingui/react";

const BookingCreatedSuccessModal = ({ visible, onClose }) => {
    return (
        <Modal
            open={visible}
            footer={null}
            onCancel={onClose}
            centered
            width={500}
        >
            <Result
                status="success"
                title={<Trans id='bookingSuccess.title' />}
                subTitle={<Trans id='bookingSuccess.subTitle' />}
                extra={[
                    <Button key="close" onClick={onClose}>
                        Փակել
                    </Button>,
                ]}
            />
        </Modal>
    );
};

export default BookingCreatedSuccessModal;
